import React from 'react'
import PropTypes from 'prop-types'

import { Form, Header, Icon, Modal } from 'semantic-ui-react'

import Container from './MySearchesSaveModalContainer'

import Button from 'Components/StandardButton'

import * as styles from './styles'

const MySearchesSaveModal = props => {
  const { done, error, handleName, handleSubmit, name, open, pending, toggle } = props

  return (
    <Modal onClose={toggle} open={open} size="small">
      <Modal.Header>Save Search</Modal.Header>

      <Modal.Content>
        {done && (
          <div style={styles.alignCenter}>
            <Icon name="check" size="massive" />
            <Header content="Your search was saved." />
            <br />
          </div>
        )}

        {!done && (
          <Form loading={pending} onSubmit={handleSubmit}>
            <Form.Field>
              <Form.Input
                icon="tag"
                iconPosition="left"
                label="Name"
                name="name"
                onChange={handleName}
                placeholder="Name"
                type="text"
                value={name}
                required
              />
            </Form.Field>

            <div style={styles.alignRight}>
              <Button content="Save Search" icon={error ? 'warning sign' : 'save'} pending={pending} />
            </div>
          </Form>
        )}
      </Modal.Content>

      <Modal.Actions>
        <Button color="black" content="Close" icon={'x'} onClick={toggle} />
      </Modal.Actions>
    </Modal>
  )
}

MySearchesSaveModal.propTypes = {
  done: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  handleName: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  pending: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default Container(MySearchesSaveModal)
